var Soladmin = {

    init: function() {
        Soladmin.bindDummyAcademicYear();
        Soladmin.bindReloadSchoolsStats();
        Soladmin.bindImport();
    },

    bindDummyAcademicYear: function() {
        $('#dummy-academic-year').on('change', function () {
            var academicYear = $(this).children('option:selected').val();
            var startYear = academicYear.substring(0, 4);
            var endYear = academicYear.substring(5, 9);
            $('.term-date').each(function () {
                var termDate = $(this).val();
                var year = termDate.substring(0, 4);
                var month = termDate.substring(5, 7);
                if (month > 08) {
                    termDate = startYear + termDate.substring(4, 10);
                } else {
                    termDate = endYear + termDate.substring(4, 10);
                }
                $(this).val(termDate);
            });
        });
    },

    bindReloadSchoolsStats: function() {
        //$('.user-count').hover(function(){
        $('#user-data').hide();
        $('.user-count').on('click', function(){
            $('#user-data').toggle();
            clearInterval(refreshStatsId);
            var refreshStatsId = setInterval(function () {
                $.get('/soladmin/people/stats', function(items) {
                    $('#user-count').text(items['users']);
                    $('#active-count').text(items['activeUsers']);
                    $('#active-schools').text(items['activeSchools']);
                    (items['activeSchools'] != 1) ? $('#school-number').text('Schools') : $('#school-number').text('School');
                    $('#user-data').html(items['userData']);
                    $('#pupil-count').text(items['pupils']);
                });
            }, 5000);
        });
        $(window).unload(function() {
            if (window.location.pathname == '/soladmin/people') {
                console.log("you are leaving Soladmin > People page");
                clearInterval(refreshStatsId);
                //$('#user-data').toggle();
            }
        });
    },

    bindImport: function() {
        $('#import').submit(function() {
            var form = $(this);
            var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
            form.find("button[type='submit']").html(html).attr('disabled', true);
        });
    },

};